import { z } from 'zod';

/**
 * `GET /voll-wallet/policy` — o termo da política da wallet ("li e concordo" do app legado):
 * `pending` quando o perfil do viajante exige o aceite e ele ainda não deu; `text` são as regras
 * que a empresa escreveu, mostradas antes da folha.
 */
export const VollWalletPolicySchema = z
  .object({ pending: z.boolean(), text: z.string().nullable() })
  .strict();
export type VollWalletPolicy = z.infer<typeof VollWalletPolicySchema>;
